import React from 'react';
import { Container, Row, Col } from 'src/interface/basics/grids';
import { Header, HeaderInner, HeaderBg, HeaderBody, HeaderPretitle, HeaderTitle, HeaderSubtitle, HeaderText, HeaderBtns } from 'src/interface/basics/headers';
import { BtnNextLink } from 'src/interface/basics/links';
import ShapesAnimation from 'src/interface/animations/shapes-animation';

const AboutHeader = () => {

  return (
    <Header className='py-5 gradient-primary-accent'>
      <HeaderInner className='mvh-40'>
        <Container className='z-20' fluid='md'>
          <Row>
            <Col lg={8}>
              <HeaderBody className='animate fade-in-up delay-200'>
                <HeaderPretitle>About Us</HeaderPretitle>
                <HeaderTitle>Your Digital Artisans</HeaderTitle>
                <HeaderText>
                  Our team found their passion for technology working on startups
                  where we learned how to design, build, and scale quickly and efficiently.
                </HeaderText>
                <HeaderBtns className='animate fade-in-up delay-400'>
                  <BtnNextLink to='/contact' className='btn btn-opaque-white btn-lg'>Contact Us</BtnNextLink>
                </HeaderBtns>
              </HeaderBody>
            </Col>
          </Row>
        </Container>
      </HeaderInner>
      <ShapesAnimation />
    </Header>
  )
}

export default AboutHeader;
